import { useState } from 'react';
import { styled, useTheme } from '@mui/material/styles';
import { Drawer } from '@mui/material';

import { NavbarAdminMenu } from 'src/layouts/dashboard/navbar/admin/NavbarAdminMenu';
import { NavbarMemberMenu } from 'src/layouts/dashboard/navbar/member/NavbarMemberMenu';
import { useRouter } from 'next/router';
import useResponsive from 'src/hooks/useResponsive';
import HamburgerButton from 'src/layouts/dashboard/navbar/HamburgerButton';

const RootStyle = styled('div')(({ theme }) => ({
  [theme.breakpoints.up('md')]: {
    flexShrink: 0,
    transition: theme.transitions.create('width', {
      duration: theme.transitions.duration.shorter,
    }),
  },
}));

export type RoleNavbar = 'admin' | 'member';

export default function Navbar() {
  const theme = useTheme();
  const router = useRouter();

  const [role, setRole] = useState<RoleNavbar>(
    router.pathname.includes('admin') ? 'admin' : 'member'
  );
  const isTablet = useResponsive('down', 'md');
  const [isCollapseOpen, setIsCollapseOpen] = useState(false);

  if (isTablet) {
    return (
      <RootStyle
        sx={{
          width: isCollapseOpen ? '200px' : '50px',
        }}
      >
        <Drawer
          open
          variant="persistent"
          PaperProps={{
            sx: {
              width: isCollapseOpen ? '200px' : '50px',
              height: isCollapseOpen ? '100%' : '50px',
              backgroundColor: theme.palette.background.paper,
              border: `1px solid ${theme.palette.grey[300]}`,
              transition: (theme) =>
                theme.transitions.create('width', {
                  duration: theme.transitions.duration.standard,
                }),
            },
          }}
        >
          <HamburgerButton
            isCollapseOpen={isCollapseOpen}
            onToggleCollapse={() => setIsCollapseOpen((prev) => !prev)}
          />
          {isCollapseOpen &&
            (role === 'member' ? (
              <NavbarMemberMenu setRole={setRole} />
            ) : (
              <NavbarAdminMenu setRole={setRole} />
            ))}
        </Drawer>
      </RootStyle>
    );
  }

  return (
    <RootStyle
      sx={{
        width: '200px',
      }}
    >
      <Drawer
        open
        variant="persistent"
        PaperProps={{
          sx: {
            width: '200px',
            backgroundColor: theme.palette.background.paper,
            borderRight: `1px solid ${theme.palette.grey[300]}`,
            transition: (theme) =>
              theme.transitions.create('width', {
                duration: theme.transitions.duration.standard,
              }),
          },
        }}
      >
        {role === 'member' ? (
          <NavbarMemberMenu setRole={setRole} />
        ) : (
          <NavbarAdminMenu setRole={setRole} />
        )}
      </Drawer>
    </RootStyle>
  );
}
